import { FieldsetLayoutWidget, Widget } from './widget';

export abstract class FieldsetWidget<T extends Widget = Widget> extends FieldsetLayoutWidget<T> { }
